<template>
	<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 1.5H13.5C14.3284 1.5 15 2.17157 15 3V4.5L7.5 7.5L0 4.5V3C0 2.17157 0.671573 1.5 1.5 1.5ZM1.5 13.5C0.671573 13.5 0 12.8284 0 12V6L7.5 9L15 6V12C15 12.8284 14.3284 13.5 13.5 13.5H1.5Z" style="fill: var( --icon-color );"/>
	</svg>
</template>
